import { Component, OnInit, Inject, ChangeDetectorRef } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { AgentlocationService } from '../../services/agent_location/agentlocation.service';
import { UploadService } from '../../services/upload/upload.service';
import { ParComplaintsTasksService } from './../../services/par_complaints_tasks/par-complaints-tasks.service';
import {documentInformation, documentInformationList} from '../../model/document.model';
import { NgForm } from '@angular/forms';
import * as momenttimezone from 'moment-timezone';
import { GoogleAnalyticsService } from '../../services/google_analytics/google-analytics.service';
import { environment } from '../../../environments/environment';
declare let ga: any;
@Component({
  selector: 'app-manage-complaints-edittask',
  templateUrl: './manage-complaints-edittask.component.html',
  styleUrls: ['./manage-complaints-edittask.component.css']
})
export class ManageComplaintsEdittaskComponent implements OnInit {
  typeErr = false;
  errMsg = '';
  readonly: boolean = true;
  statusData = ['Yes', 'No'];
  documentInfo: documentInformationList = new documentInformationList();
  isFileChanged: boolean = false;
  matSpinner: boolean = false;
  signedUrl;
  ManageTypeErrMsg: string;
  ManageTypeErr: boolean;
  task_doc_id: any;

  taskData = {
    ComplaintStatus: '',
    complaint_type: '',
    master_vendor_name: '',
    master_vendor_id: '',
    vendor_location: '',
    vendor_location_id: '',
    due_date: new Date,
    date: new Date,
    complainant: '',
    email: '',
    notes: '',
    request: '',
    amount: '',
    document_name: [],
    document_link: [],
    attach_document: false,
    complaint_id: '',
    task_status: '',
    updated_by: ''
  }
  firstName;
  lastName;
  constructor(@Inject(MAT_DIALOG_DATA) public taskInfo: any,
              public agentLocationService: AgentlocationService,
              public dialogRef: MatDialogRef<ManageComplaintsEdittaskComponent>,
              public ref: ChangeDetectorRef,
              public uploadService: UploadService,
              public parComplaintsTasksService: ParComplaintsTasksService,
              private googleAnalyticsService: GoogleAnalyticsService) { }

  ngOnInit() {
    this.firstName =  localStorage.getItem("username");
    this.lastName = localStorage.getItem('Lastname');
    
    this.task_doc_id = this.taskInfo.taskInfo.Doc_Id;
    this.taskData.master_vendor_name = this.taskInfo.taskInfo.MasterVendorName;
    this.taskData.request = this.taskInfo.taskInfo.Request;
    this.taskData.complaint_type = this.taskInfo.taskInfo.ComplaintType[0].ComplaintType;
    this.taskData.email = this.taskInfo.taskInfo.Email;
    this.taskData.task_status = this.taskInfo.taskInfo.Status;
    this.taskData.ComplaintStatus = this.taskInfo.taskInfo.ComplaintStatus;
    this.taskData.date = new Date(this.taskInfo.taskInfo.LogDate);
    this.taskData.amount = this.taskInfo.taskInfo.Amount;
    this.taskData.notes = this.taskInfo.taskInfo.Notes;
    this.taskData.document_name = this.taskInfo.taskInfo.DocumentName;
    this.taskData.document_link = this.taskInfo.taskInfo.DocumentLink;
    this.taskData.complaint_id = this.taskInfo.taskInfo.ComplaintId;
    this.taskData.vendor_location_id = this.taskInfo.taskInfo.VendorLocationId;
    this.taskData.master_vendor_id = this.taskInfo.taskInfo.MasterVendorId;
    this.taskData.complainant = this.taskInfo.taskInfo.Complainant;
    this.taskData.attach_document = this.taskInfo.taskInfo.AttachDocument == "true" ? true : false;
    this.taskData.updated_by = localStorage.getItem('loginID') ? localStorage.getItem('loginID') : '';
    let dueDate = new Date(this.taskInfo.taskInfo.DueDate);
    if (dueDate)
      this.taskData.due_date = dueDate;

    this.agentLocationService.locationDetsOfAgent(this.taskInfo.taskInfo.VendorLocationId, this.taskInfo.taskInfo.MasterVendorId).subscribe(res => {
      this.typeErr = false;
      this.errMsg = '';
      if (res) {
        if (res.vendorLocationDetails[0] && res.vendorLocationDetails[0].Address1 !== undefined && res.vendorLocationDetails[0].Address1 !== null)
          this.taskData.vendor_location = res.vendorLocationDetails[0].Address1;
        if (res.vendorLocationDetails[0] && res.vendorLocationDetails[0].Address2 !== undefined && res.vendorLocationDetails[0].Address2 !== null)
          this.taskData.vendor_location = this.taskData.vendor_location + " " + res.vendorLocationDetails[0].Address2;
        if (res.vendorLocationDetails[0] && res.vendorLocationDetails[0].City !== undefined && res.vendorLocationDetails[0].City !== null)
          this.taskData.vendor_location = this.taskData.vendor_location + " " + res.vendorLocationDetails[0].City;
        if (res.vendorLocationDetails[0] && res.vendorLocationDetails[0].State !== undefined && res.vendorLocationDetails[0].State !== null)
          this.taskData.vendor_location = this.taskData.vendor_location + " " + res.vendorLocationDetails[0].State;
        if (res.vendorLocationDetails[0] && res.vendorLocationDetails[0].PostalCode !== undefined && res.vendorLocationDetails[0].PostalCode !== null)
          this.taskData.vendor_location = this.taskData.vendor_location + " " + res.vendorLocationDetails[0].PostalCode;
      } else {
        this.taskData.vendor_location = "";
      }
    }, err => {
      this.errMsg = "Agent Location Service Error while fetching Location Addresses in Edit Complaint Task " + err;
      this.typeErr = true;
    });
  }

  onNoClick() {
    this.dialogRef.close();
  }

  setFileData(docInfo) {
    //this.googleAnalyticsService.emitEvent(this.firstName + ' ' + this.lastName, "Upload a" + ' ' + this.agentdata.data.DocumentTypeName + ' ' + 'Document', this.vendorName, 10);
    setTimeout(() => {
      this.documentInfo = docInfo;
      this.taskData.document_name = this.documentInfo.fileName;
      this.ref.markForCheck();
      this.ref.detectChanges()
    }, 100);
    this.isFileChanged = true;
  }

  onFormSubmit(form: NgForm) {
    this.taskData.complainant = form.value.Complainant;
    this.taskData.attach_document = form.value.AttachDocument;
    this.taskData.email = form.value.Email;
    this.taskData.task_status = form.value.status;
    this.taskData.amount = form.value.Amount !== null ? form.value.Amount : 0;
    this.taskData.notes = form.value.Comment;
    if (!this.isFileChanged) {
      this.taskData.document_name = this.taskInfo.taskInfo.DocumentName;
      this.taskData.document_link = this.taskInfo.taskInfo.DocumentLink;
      this.submit(this.taskData);
    } else {
      this.taskData.document_name = [];
      this.taskData.document_link = [];
      let today = new Date();
      const estTimeZone = 'America/New_York';
      let uploadTimeZone = momenttimezone(today).tz(estTimeZone).format();
      uploadTimeZone = uploadTimeZone.replace(/[^a-zA-Z0-9]/g, '');
      var filePath = "Complaint/" + this.taskData.complaint_id + "/TaskDocs/";

      for (var j=0; j < this.documentInfo.file.length; j++) {
        this.taskData.document_name.push(this.documentInfo.fileName[j]);
        let fileNameWithoutExt = this.documentInfo.fileName[j].substring(0, this.documentInfo.fileName[j].lastIndexOf('.'));
        let fileNameExt = this.documentInfo.fileName[j].substring(this.documentInfo.fileName[j].lastIndexOf('.') + 1,
                                                                  this.documentInfo.fileName[j].length);
        this.documentInfo.fileInput[j].append('url', filePath + fileNameWithoutExt + '_' + uploadTimeZone + '.' + fileNameExt);
        let newFilePath1 = filePath + fileNameWithoutExt + '_' + uploadTimeZone + '.' + fileNameExt;
        let body = {
          "newFilePath": newFilePath1,
        }
        this.taskData.document_link.push(newFilePath1);
        let file = this.documentInfo.file[j];
        this.uploadService.getSignedURL(body).subscribe((res) => {
          this.signedUrl = res.Info;
          this.uploadService.uploadDocumentWithSignedUrl(file, this.signedUrl).subscribe((obj) => {
            //this.submit(this.taskData);
          });
        }, error => {
          this.errMsg = "Upload Request Service " + error;
          this.typeErr = true;
          this.matSpinner = false;
        });
      }
      this.submit(this.taskData);
    }
  }

  submit(taskData) {
    delete this.taskData.complaint_type;
    delete this.taskData.vendor_location;
    delete this.taskData.date;
    this.matSpinner = true;
    this.parComplaintsTasksService.updateTaskService(taskData, this.task_doc_id).subscribe(res => {
      ga('CompliantsTracker.send', 'event',this.firstName + ' ' + this.lastName,environment.googleAnalyticsEvents[4],this.taskData.email, 1);
      // this.googleAnalyticsService.emitEvent(this.firstName + ' ' + this.lastName,environment.googleAnalyticsEvents[4],this.taskData.email, 1);
      this.matSpinner = false;
      this.parComplaintsTasksService.load.next('success');
      this.dialogRef.close();
    }, error => {
      this.ManageTypeErrMsg = 'Update Par Complaint Task Service' + ' ' + error;
      this.ManageTypeErr = true;
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/components/manage-complaints-edittask/manage-complaints-edittask.component.ts